namespace TabAurous.ECommerce {
    export interface ECommRefundDetailsForm {
        TransDetailId: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        Mode: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        RefNo: Serenity.StringEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
    }

    export class ECommRefundDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommRefundDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommRefundDetailsForm.init)  {
                ECommRefundDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;

                Q.initFormType(ECommRefundDetailsForm, [
                    'TransDetailId', w0,
                    'LedgerId', w1,
                    'Mode', w1,
                    'Amount', w2,
                    'RefNo', w0,
                    'ChequeNo', w0,
                    'ChequeDate', w3
                ]);
            }
        }
    }
}
